/**
 * Parses a data attribute value. If the value is an empty string, it will return `null`.
 * Otherwise it will attempt to parse the value as JSON. If that fails,
 * it will return the original value.
 */
export function parseDataAttribute(value) {
    if (value === '') {
        return null;
    }
    try {
        const parsedValue = JSON.parse(value);
        return parsedValue;
    }
    catch (error) {
        return value;
    }
}
